export const linkRGCBarcodeMutation = `
mutation linkRGCBarcode($input: LinkRGCBarcodeInput!) {
    linkRGCBarcode(input: $input) {
        aliquotId
        rgcBarcode
    },
}
`;

export const createSampleBatchMutation = `
mutation createSampleBatch($input: CreateSampleBatchInput!) {
    createSampleBatch(input: $input) {
        batchId
    },
}
`;

export const createCryoboxMutation = `
mutation createCryobox($input: CreateCryoboxInput!) {
    createCryobox(input: $input) {
        serialNo
    },
}
`;

export const updateCryoboxMutation = `
mutation updateCryobox($input: UpdateCryoboxInput!) {
    updateCryobox(input: $input) {
        aliquotPositions
        aliquotPositionTimestamps
        bioBanked
        createdBy
        createdTs
        freezer {
        freezerId
        name
        serialNo
        temp
        }
        freezerShelfNo
        height
        lastUpdatedBy
        rackPositionNo
        sampleType
        serialNo
        cryoboxUuid
        cryoboxBarcode
        shelfRackNo
        updatedTs
        width
    },
}
`;

export const requestSampleExport = `
mutation requestSampleExport($exportType: ExportType!) {
    requestSampleExport(exportType: $exportType) {
        runId
    }
}`;

export const createStagedShipmentMutation = `
mutation createStagedShipment($destination: String!, $shipmentType: ShipmentTypeEnum!, $plannedShipmentDate: String!) {
  createStagedShipment(destination: $destination, shipmentType: $shipmentType, plannedShipmentDate: $plannedShipmentDate) {
    stagedShipmentMetaUuid
  }
}
`;

export const addCryoboxToStagingMutation = `
mutation addCryoboxToStaging($cryoboxUuid: String, $cryoboxBarcode: String) {
  addCryoboxToStaging(cryoboxUuid: $cryoboxUuid, cryoboxBarcode: $cryoboxBarcode) {
    cryoboxUuid
  }
}
`;

export const removeCryoboxFromStagingMutation = `
mutation removeCryoboxFromStaging($cryoboxUuid: String!) {
  removeCryoboxFromStaging(cryoboxUuid: $cryoboxUuid) {
    cryoboxUuid
  }
}
`;

export const resetStagedShipmentMutation = `
  mutation {
    resetStagedShipment {
      stagedShipmentMetaUuid
    }
  }
`;

export const moveStagedAliquotMutation = `
mutation moveStagedAliquot($aliquotUuid: String!, $updatedCryoboxBarcode: String!, $updatedCryoboxPosition: Int!) {
  moveStagedAliquot(aliquotUuid: $aliquotUuid, updatedCryoboxBarcode: $updatedCryoboxBarcode, updatedCryoboxPosition: $updatedCryoboxPosition) {
    aliquotUuid
  }
}
`;

export const manifestStagedShipmentMutation = `
  mutation {
    manifestStagedShipment {
      shipmentId
    }
  }
`;

export const finaliseShipmentMutation = `
mutation shipManifestedShipment($shipmentId: String!, $shippedDate: String!) {
  shipManifestedShipment(shipmentId: $shipmentId, shippedDate: $shippedDate) {
    shipmentUuid
  }
}
`;

export const shipmentConfirmQCMutation = `
mutation confirmShipmentQCPass {
  confirmShipmentQCPass {
    stagedShipmentMetaUuid
  }
}
`;
